import { iots, pipe } from '@code-expert/prelude';
import { AppAuthorise } from '/imports/modules/API/presentation/AppAuthorise';
import { end, lit, parser, query, succeed, url } from '/imports/modules/Routing';
import { Authorise } from '/imports/ui/components/Authorise';
import NotFound from '/imports/ui/components/NotFound';
import { TopNavLayout } from '/imports/ui/layouts/TopNavLayout';

const authoriseBaseRoute = lit('app');

const authorizeRoute = url(
  lit('authorize'),
  query(iots.strict({ clientId: iots.string, code_challenge: iots.string })),
  end,
);

const InvalidAuthoriseLink = () => (
  <Authorise
    deny={['exam', 'lti']}
    layout={(children) => <TopNavLayout selected="app">{children}</TopNavLayout>}
  >
    <NotFound
      title="Invalid authorisation link"
      text="You have followed an invalid authorisation link."
      showBackButton={false}
    />
  </Authorise>
);

export const appRouter = pipe(
  // Match /app
  authoriseBaseRoute.parser,
  parser.chain((_) =>
    pipe(
      // Match /authorize?clientId={string}&code_challenge={string}
      authorizeRoute.parser,
      parser.map((props) => (
        <Authorise deny={['exam', 'lti']}>
          <AppAuthorise {...props} />
        </Authorise>
      )),
      // Fall back to error message
      parser.alt(succeed(<InvalidAuthoriseLink />).parser),
    ),
  ),
);
